import { render, staticRenderFns } from "./nova-empty.vue?vue&type=template&id=e0e4bd06&scoped=true&"
import script from "./nova-empty.vue?vue&type=script&lang=ts&"
export * from "./nova-empty.vue?vue&type=script&lang=ts&"
import style0 from "./nova-empty.vue?vue&type=style&index=0&id=e0e4bd06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0e4bd06",
  null
  
)

export default component.exports